import { Injectable } from '@angular/core';
import { StarbaseServicesProviderBase } from 'scaletech-core';
import { StarbaseModalDialogService } from 'starbase-modal-dialog';
import { StarbaseModalOverlayService } from 'modal-overlay';
import { StarbaseComponentMessageService } from './starbase-component-message.service';
import { StarbaseNotificationService } from 'starbase-notification';
import { StarbaseLoginService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class StarbaseServiceProviderService extends StarbaseServicesProviderBase {

  constructor(
    modalSvc: StarbaseModalDialogService,
    overlaySvc: StarbaseModalOverlayService,
    sbCmpMsgSvc: StarbaseComponentMessageService,
    notificationSvc: StarbaseNotificationService,
    loginSvc: StarbaseLoginService) {
    super(modalSvc, overlaySvc, sbCmpMsgSvc, notificationSvc, loginSvc);
  }
}
